<!--
Author: TangChen
Date: 2018-10-23
Desc: 现金宝购买区别信息，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-currency-info bizcomp ' + className">
        <comp-title :title="title" />
        <div class="xjb-info">
            <div class="xjb-info-text">高人气现金宝 可支持快赎</div>
            <el-row class="xjb-process">
                <el-col :span="6">
                    <span>充</span>
                </el-col>
                <el-col :span="6">
                    <div class="steps-all">
                        <span class="steps-img" />
                        <span class="steps-action">充值实时到账</span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="steps-all">
                        <span class="steps-img icon00" />
                        <span class="steps-action">购买基金</span>
                        <span class="steps-action-text">现金宝买基金费率更低</span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="steps-all">
                        <span class="steps-img icon01" />
                        <span class="steps-action">T+1</span>
                        <span class="steps-action-text">开始计算收益</span>
                    </div>
                    <div class="steps-all right-end">
                        <span class="steps-img icon02" />
                        <span class="steps-action">T+2</span>
                        <span class="steps-action-text">收益可见</span>
                    </div>
                </el-col>
            </el-row>
            <el-row class="xjb-process">
                <el-col :span="6">
                    <span>充</span>
                </el-col>
                <el-col :span="6">
                    <div class="steps-all">
                        <span class="steps-img" />
                        <span class="steps-action">充值</span>
                        <span class="steps-action-text">T日15:00前</span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="steps-all">
                        <span class="steps-img icon01" />
                        <span class="steps-action">T+1</span>
                        <span class="steps-action-text">开始计算收益</span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="steps-all">
                        <span class="steps-img icon02" />
                        <span class="steps-action">T+2</span>
                        <span class="steps-action-text">收益可见</span>
                    </div>
                    <em />
                </el-col>
            </el-row>
            <el-row class="xjb-process sell">
                <el-col :span="6">
                    <span>取</span>
                </el-col>
                <el-col :span="6">
                    <div class="steps-all">
                        <span class="steps-img icon03" />
                        <span class="steps-action">快速赎回</span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="steps-all">
                        <span class="steps-img icon04" />
                        <span class="steps-action">实时到账</span>
                    </div>
                    <em />
                </el-col>
            </el-row>
            <el-row class="xjb-process sell">
                <el-col :span="6">
                    <span>取</span>
                </el-col>
                <el-col :span="6">
                    <div class="steps-all">
                        <span class="steps-img icon03" />
                        <span class="steps-action">普通赎回</span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="steps-all">
                        <span class="steps-img icon05" />
                        <span class="steps-action">T+1到账</span>
                    </div>
                    <em />
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "CurrencyInfo",
    mixins: [mixin],
    data() {
        return {};
    },
    methods: {}
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-currency-info {
    .xjb-info {
        padding: 27px 50px 27px 23px;
        .xjb-info-text {
            font-size: $f24;
            color: var(--color-primary);
            line-height: 30px;
            text-align: center;
            margin-bottom: 20px;
        }
        .xjb-process {
            height: 180px;
        }
        .xjb-process.sell {
            height: 170px;
        }
        .xjb-process.sell .el-col {
            background: $color-d-m;
            &:first-of-type span {
                background: linear-gradient(to right top, #52d065, #cbda13);
            }
            &:last-of-type em {
                background-color: $color-d-m;
            }
            .steps-all .steps-img {
                border-color: $color-d-m;
            }
        }
        .xjb-process .el-col {
            position: relative;
            height: 2px;
            margin-top: 60px;
            background: var(--color-primary);
            &:first-of-type span {
                width: 46px;
                height: 46px;
                display: block;
                position: absolute;
                text-align: center;
                line-height: 46px;
                left: 0;
                top: -23px;
                border-radius: 100%;
                font-size: $f18;
                color: $text-color6;
                background: linear-gradient(to right top, #f06a37, #eda531);
            }
            &:last-of-type em {
                position: absolute;
                width: 20px;
                height: 20px;
                top: -9px;
                right: 0;
                display: block;
                font-size: $f18;
                color: $text-color6;
                background-color: var(--color-primary);
                border-radius: 100%;
                text-align: center;
                &.el-icon-arrow-right {
                    width: 30px;
                    height: 30px;
                    top: -14px;
                    line-height: 30px;
                }
            }
            .steps-all {
                position: absolute;
                left: -50px;
                width: 100px;
                top: -49px;
                text-align: center;
                &.right-end {
                    left: 100%;
                    margin-left: -72px;
                }
                .steps-img {
                    width: 96px;
                    height: 96px;
                    display: block;
                    border-radius: 100%;
                    border: 2px solid var(--color-primary);
                    background: #f9f1e3 url($icon) 19px -185px no-repeat;
                    &.icon00 {
                        background: #f9f1e3 url($icon) -311px -271px no-repeat;
                    }
                    &.icon01 {
                        background: #f9f1e3 url($icon) -87px -182px no-repeat;
                    }
                    &.icon02 {
                        background: #f9f1e3 url($icon) -200px -186px no-repeat;
                    }
                    &.icon03 {
                        background: #f9f1e3 url($icon) 19px -269px no-repeat;
                    }
                    &.icon04 {
                        background: #f9f1e3 url($icon) -86px -270px no-repeat;
                    }
                    &.icon05 {
                        background: #f9f1e3 url($icon) -191px -271px no-repeat;
                    }
                }
                .steps-action {
                    color: var(--color-primary);
                    font-size: $f16;
                    display: block;
                    line-height: 36px;
                }
                .steps-action-text {
                    color: $text-color2;
                }
            }
        }
    }
}
</style>
